// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertySingleLinePDF {
  border-top: 4px solid black;
  border-bottom: 4px solid black;
  display: flex;
  flex-direction: row;
  font-size: 1.0em;
  font-family: sans-serif;
  background-color: white;
  text-align: left;
  flex-wrap: wrap;
}

.PropertySingleLinePDF .pslpdf-entry {
  border-bottom: 1px solid black;
  font-size: 1.4em;
  border: 1px solid black;
  height: 4em;
  display: flex;
  flex-direction: column;
  padding: 0.4em 0.4em;
}
.PropertySingleLinePDF .pslpdf-entry div:nth-child(1) {
  background-color: #ddd;
  font-weight: bold;
}
.PropertySingleLinePDF .pslpdf-entry div:nth-child(2) {
}
.PropertySingleLinePDF .pslpdf-cell {
}
.pslpdf-address {
  background-color: #191f5a;
  color: white;
  font-size: 2em;
  text-align: left;
  padding-left: 0.4em;
}
.pslpdf-expired {
  color: red;
}
.pslpdf-withdrawn {
  color: blue;
}
.pslpdf-sold {
  color: blue;
}
.pslpdf-active {
  color: green;
}
.pslpdf-separator {
  width: 100%;
  border-bottom: 1px dotted black;
}

.pslpdf-lhe-link a {
  font-size: 14px;
}
.pslpdf-flat-gallery-wrapper {
  padding-left: 0em;
  padding-right: 0em;
  padding-top: 1em;
  padding-bottom: 1em;
  display: flex;
  flex-direction: row-reverse;
  margin: 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/share-to-pdf/PropertySingleLine.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;AACA;AACA;AACA;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb","sourcesContent":[".PropertySingleLinePDF {\n  border-top: 4px solid black;\n  border-bottom: 4px solid black;\n  display: flex;\n  flex-direction: row;\n  font-size: 1.0em;\n  font-family: sans-serif;\n  background-color: white;\n  text-align: left;\n  flex-wrap: wrap;\n}\n\n.PropertySingleLinePDF .pslpdf-entry {\n  border-bottom: 1px solid black;\n  font-size: 1.4em;\n  border: 1px solid black;\n  height: 4em;\n  display: flex;\n  flex-direction: column;\n  padding: 0.4em 0.4em;\n}\n.PropertySingleLinePDF .pslpdf-entry div:nth-child(1) {\n  background-color: #ddd;\n  font-weight: bold;\n}\n.PropertySingleLinePDF .pslpdf-entry div:nth-child(2) {\n}\n.PropertySingleLinePDF .pslpdf-cell {\n}\n.pslpdf-address {\n  background-color: #191f5a;\n  color: white;\n  font-size: 2em;\n  text-align: left;\n  padding-left: 0.4em;\n}\n.pslpdf-expired {\n  color: red;\n}\n.pslpdf-withdrawn {\n  color: blue;\n}\n.pslpdf-sold {\n  color: blue;\n}\n.pslpdf-active {\n  color: green;\n}\n.pslpdf-separator {\n  width: 100%;\n  border-bottom: 1px dotted black;\n}\n\n.pslpdf-lhe-link a {\n  font-size: 14px;\n}\n.pslpdf-flat-gallery-wrapper {\n  padding-left: 0em;\n  padding-right: 0em;\n  padding-top: 1em;\n  padding-bottom: 1em;\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
